<template>
    <div class="resident-warpper">
        <div class="bg-white">
            <el-form :model="goodsForm" :rules="rules" ref="goodsForm" label-width="120px">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="社区：" prop="project" v-if="user.power === 3">
                            <el-select v-model="goodsForm.project" placeholder="请选择社区" style="width: 100%;" clearable>
                                <el-option v-for="item in projectList" :key="item.id" :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="活动名称" prop="name">
                            <el-input v-model="goodsForm.name" placeholder="请输入活动名称"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="活动时间" prop="time">
                            <!--                            <el-input v-model="goodsForm.time" placeholder="请输入活动时间"></el-input>-->
                            <el-date-picker v-model="goodsForm.time" type="datetime" placeholder="请选择活动时间"
                                value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%;">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="活动地址" prop="address">
                            <el-input v-model="goodsForm.address" placeholder="请输入活动地址"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="活动人数" prop="number">
                            <el-input type="number" v-model="goodsForm.number" placeholder="请输入活动人数"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="活动积分" prop="points">
                            <el-input type="number" v-model="goodsForm.points" placeholder="请输入活动积分"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" v-if="false">
                        <el-form-item label="活动类型" prop="type">
                            <el-select v-model="goodsForm.type" placeholder="请选择活动类型" style="width: 100%;">
                                <el-option v-for="item in types" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item ref="images" label="照片" prop="images">
                    <upload-file name="images" :size="50" @uploadFile="uploadFile">
                        <div class="flex align-center" slot="upload">
                            <el-button class="btn min round" type="primary">+ 上传附件</el-button>
                            <div class="tips margin-left-sm">文件不超过50M</div>
                        </div>
                    </upload-file>
                    <div class="file-container flex margin-left-sm">
                        <div class="image-item flex align-center" v-for="(item, index) in goodsForm.images"
                            :key="index">
                            <el-image :src="item.url" fit="fill" :preview-src-list="goodsForm.images"
                                class="img"></el-image>
                            <i class="el-icon-error" @click="removeImage(index)"></i>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item ref="file" label="签到表" prop="file" v-if="false">
                    <upload-file name="file" :accept="FILE_ACCEPT.ALL" :size="50" @uploadFile="uploadFile">
                        <div class="flex align-center" slot="upload">
                            <el-button class="btn min round" type="primary">+ 上传附件</el-button>
                            <div class="tips margin-left-sm">文件不超过50M</div>
                        </div>
                    </upload-file>
                    <div class="file-container flex flex-direction margin-left-sm">
                        <div class="file-item flex align-center" v-for="(item, index) in goodsForm.file" :key="index">
                            <div class="file-name cursor ovHide" v-ellipsis="item.name">
                                {{ item.name }}
                            </div>
                            <el-link class="margin-left-sm flex-shrink" @click="removeFile(index)">删除</el-link>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="活动介绍" prop="content">
                    <VueUditorWrap v-model="goodsForm.content" :config="myConfig"></VueUditorWrap>
                </el-form-item>

                <el-form-item class="flex align-center justify-around" label-width="0">
                    <el-button class="padding-lr-xl" type="primary" @click="submitForm('goodsForm')">保存</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import VueUditorWrap from 'vue-ueditor-wrap'
import { bdEditConfig, FILE_ACCEPT } from "@/utils/utils";
import { getXiangMuList } from "@/api/common";
import { addActive, getActiveDetail } from "@/api/gzh";
import UploadFile from "@/components/UploadQnFile";
export default {
    name: "shopping-add",
    components: { UploadFile, VueUditorWrap },
    data() {
        return {
            FILE_ACCEPT: FILE_ACCEPT,
            myConfig: bdEditConfig(),
            types: [
                {
                    value: 1,
                    label: '获得积分'
                },
                // {
                //     value: 2,
                //     label: '扣除积分'
                // }
            ],
            projectList: [],
            goodsForm: {
                project: '',
                name: '',
                time: '',
                address: '',
                number: '',
                points: '',
                type: '',
                content: '',
                images: [],
                file: [],
            },
            rules: {
                // project: [{ required: true, message: '请选择社区', trigger: 'blur' }],
                name: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
                time: [{ required: true, message: '请输入活动时间', trigger: 'blur' }],
                address: [{ required: true, message: '请输入活动地址', trigger: 'blur' }],
                number: [{ required: true, message: '请输入活动人数', trigger: 'blur' }],
                points: [{ required: true, message: '请输入活动积分', trigger: 'blur' }],
                type: [{ required: true, message: '请选择活动类型', trigger: 'blur' }],
                content: [{ required: true, message: '请输入活动介绍', trigger: 'blur' }],
            },
            limit: 9,
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    created() {
        this.$emit("setIndex", '/home/gzh/teams', "双暖为老 / 队伍管理 / 活动列表", true);
        if (Number(this.$route.params.id)) this.getDetail()
        this.getXiangMuList()
    },
    methods: {
        async getXiangMuList() {
            let _data = await getXiangMuList()
            this.projectList = _data.data
            if (this.user.power !== 3) {
                // this.goodsForm.project = _data.data[0].id
            }
        },
        //  获取商品详情
        async getDetail() {
            let _data = await getActiveDetail(this.$route.params.id)
            this.goodsForm.project = _data.data.xiangmu_id || ''
            this.goodsForm.name = _data.data.name
            this.goodsForm.time = _data.data.time
            this.goodsForm.address = _data.data.address
            this.goodsForm.number = _data.data.number
            this.goodsForm.points = _data.data.points
            this.goodsForm.type = _data.data.type
            this.goodsForm.content = _data.data.content
            this.goodsForm.images = _data.data.images ? JSON.parse(_data.data.images) : []
            this.goodsForm.file = _data.data.file ? JSON.parse(_data.data.file) : []
        },
        //  提交保存商品
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitData(formName)
                }
            });
        },
        async submitData(formName) {
            let _state = await addActive(
                this.goodsForm.project,
                this.goodsForm.name,
                this.goodsForm.time,
                this.goodsForm.address,
                this.goodsForm.number,
                this.goodsForm.points,
                this.goodsForm.type,
                this.goodsForm.content,
                JSON.stringify(this.goodsForm.images),
                JSON.stringify(this.goodsForm.file),
                this.$route.params.id ? this.$route.params.id : '',
            );
            this.$message.success(_state.info);
            this.$refs[formName].resetFields();
            this.$router.go(-1)
        },
        uploadFile(data) {
            this.goodsForm[data.name].push(data.file)
        },
        removeImage(index) {
            this.goodsForm.images.splice(index, 1)
        },
        removeFile(index) {
            this.goodsForm.file.splice(index, 1)
        },
    },
    filters: {},
    watch: {},
}
</script>

<style scoped lang="scss">
.image-item {
    margin-right: 10px;
    width: 100px;
    height: 100px;
    position: relative;
    margin-top: 10px;

    img {
        width: 100%;
        height: 100%;
    }

    i {
        position: absolute;
        top: -10px;
        right: -10px;
        font-size: 16px;
        color: red;
        cursor: pointer;
        width: 20px;
        height: 20px;
        line-height: 20px;
        border-radius: 50%;
        text-align: center;
    }
}
</style>
